import * as Sentry from '@sentry/ember';

import config from './config/environment';

const IGNORE_ERRORS = [
  'The adapter operation was aborted',
  'The adapter rejected the commit because it was invalid',
  'Non-Error exception captured with keys',
  'Attempted to handle event `deleteRecord`', // ember-data internal
  'Attempted to handle event `pushedData`', // idem
  "Cannot read property '_avast_submit' of undefined", //Avast extension error https://github.com/getsentry/sentry/issues/9331
  'Out of stack space', // Edge error
];

export function init() {
  Sentry.init({
    ...config.sentry,

    allowUrls: [
      // Production:
      /^https:\/\/pay\.qonto\.com/,
      // Staging:
      /^https:\/\/[^/]+.staging\.qonto\.co/,
      // Mollie.js
      /^https:\/\/js\.mollie\.com\/v1\/mollie\.js/,
    ],

    beforeSend(event, hint) {
      let error = hint.originalException;

      if (error) {
        // ignore cancelation errors from the Ember router of ember-concurrency
        if (error.name === 'TaskCancelation' || error.name === 'TransitionAborted') {
          return null;
        }

        // ignore errors that contains strings from the IGNORE_ERRORS array
        if (error.message && IGNORE_ERRORS.some(it => error.message.includes(it))) {
          return null;
        }

        // A lot of the "TypeError: Failed to fetch" issues on Sentry are caused by misbehaving Chrome extensions.
        // The two most common ones load JS code from `/scripts/js` or `/scripts/jt`, so here we filter out any
        // errors that contain these paths in their stacktrace. Technically the `allowUrls` option above should
        // already filter them out, but for some reason that does not appear to work in this case.
        if (error.stack?.includes('/scripts/js') || error.stack?.includes('/scripts/jt')) {
          return null;
        }
      }

      return event;
    },
  });

  Sentry.setTag('CFT', 'accounts-receivable');
}
